// Sidebar route metadata
export class RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  groupTitle: boolean;
  submenu: RouteInfo[];
}
